import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "./include/PageTitle";
import { useI18n } from "../i18n/I18nContext";
import { getServiceDetailsCopy, getSidebarLinks } from "../content/localeCopy";
import LocalizedLeadParagraph from "../Components/LocalizedLeadParagraph";
import { useTranslatedCopy } from "../i18n/useTranslatedCopy";
import ServiceInquiryForm from "../Components/ServiceInquiryForm";
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServiceStructuredData } from "../Components/Seo";

const propertyManagementPageImages = [
  "/img/service/brokerage-service-3.png",
  "/img/service/property-management-service-2.png",
  "/img/service/property-management-service-1.png",
];

const propertyManagementSidebarImage = "/img/service/property-management-service-4.png";

const imageCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(187, 165, 92, 0.14)",
  borderRadius: "22px",
  overflow: "hidden",
  boxShadow: "0 16px 38px rgba(15, 23, 42, 0.08)",
  height: "100%",
};

const PropertyManagementServiceDetails = () => {
  const { locale } = useI18n();
  const copy = useTranslatedCopy(getServiceDetailsCopy("property-management"), locale);
  const sidebar = useTranslatedCopy(getSidebarLinks(), locale);
  const moreDetailsHeading = useTranslatedCopy("More about this service", locale);
  const matrixHeaderService = useTranslatedCopy("Service", locale);
  const matrixHeaderDetails = useTranslatedCopy("What We Provide", locale);
  const galleryCaptionOne = useTranslatedCopy("Property upkeep and operational support", locale);
  const galleryCaptionTwo = useTranslatedCopy("Landscape quality and exterior presentation", locale);

  const managementGalleryTitle = useTranslatedCopy("How we manage and protect property value", locale);
  const managementGalleryText = useTranslatedCopy(
    "These service areas reflect the practical side of property management, from daily follow-up and site supervision to maintenance coordination and presentation standards.",
    locale
  );

  return (
    <div>
      <Seo
        title="Property Management in Saudi Arabia and Al Khobar | QTECH"
        titleAr="إدارة أملاك في الخبر والسعودية | شركة تقنيات الجودة"
        description="QTECH provides property management services in Saudi Arabia and Al Khobar for residential and commercial assets, including lease management, rent collection, maintenance oversight, tenant coordination, and reporting."
        descriptionAr="تقدم شركة تقنيات الجودة خدمات إدارة أملاك وإدارة عقارات في الخبر والسعودية تشمل متابعة المستأجرين، تحصيل الإيجارات، صيانة العقارات، وإدارة العقارات السكنية والتجارية."
        keywords={ENGLISH_SEO_KEYWORDS.propertyManagement}
        keywordsAr={ARABIC_SEO_KEYWORDS.propertyManagement}
        path="/property-management-saudi-arabia"
        image={propertyManagementPageImages[0]}
        structuredData={buildServiceStructuredData({
          name: "Property Management | QTECH",
          nameAr: "Ø¥Ø¯Ø§Ø±Ø© Ø£Ù…Ù„Ø§Ùƒ ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø³Ø¹ÙˆØ¯ÙŠØ© | Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø©",
          description:
            "QTECH provides property management services in Saudi Arabia for residential and commercial assets, including lease management, rent collection, maintenance oversight, tenant coordination, and reporting.",
          descriptionAr:
            "ØªÙ‚Ø¯Ù… Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø© Ø®Ø¯Ù…Ø§Øª Ø¥Ø¯Ø§Ø±Ø© Ø£Ù…Ù„Ø§Ùƒ ÙˆØ¥Ø¯Ø§Ø±Ø© Ø¹Ù‚Ø§Ø±Ø§Øª ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø³Ø¹ÙˆØ¯ÙŠØ© ØªØ´Ù…Ù„ Ù…ØªØ§Ø¨Ø¹Ø© Ø§Ù„Ù…Ø³ØªØ£Ø¬Ø±ÙŠÙ†ØŒ ØªØ­ØµÙŠÙ„ Ø§Ù„Ø¥ÙŠØ¬Ø§Ø±Ø§ØªØŒ ØµÙŠØ§Ù†Ø© Ø§Ù„Ø¹Ù‚Ø§Ø±Ø§ØªØŒ ÙˆØ¥Ø¯Ø§Ø±Ø© Ø§Ù„Ø¹Ù‚Ø§Ø±Ø§Øª Ø§Ù„Ø³ÙƒÙ†ÙŠØ© ÙˆØ§Ù„ØªØ¬Ø§Ø±ÙŠØ©.",
          path: "/property-management-saudi-arabia",
          image: propertyManagementPageImages[0],
          serviceType: "Property Management",
        })}
      />

      <PageTitle
        title={copy.title}
        currentPage={copy.title}
        bgImage="/img/bg/14.jpg"
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <div className="ltn__blog-img">
                  <img
                    src={propertyManagementPageImages[0]}
                    alt={copy.imageLabel}
                    style={{ width: "100%", minHeight: "460px", objectFit: "cover" }}
                  />
                </div>

                <h2 className="title-2">{copy.imageLabel}</h2>

                {copy.paragraphs.map((text, index) => (
                  <LocalizedLeadParagraph
                    key={index}
                    text={text}
                    index={index}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.highlights) && copy.highlights.length > 0 ? (
                  <div className="qtech-service-highlight-list">
                    {copy.highlights.map((item, index) => (
                      <div className="qtech-service-highlight-card" key={item.title || index}>
                        <h5>{item.title}</h5>
                        <p>{item.body}</p>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div
                  style={{
                    marginTop: "34px",
                    marginBottom: "18px",
                    padding: "0 2px",
                  }}
                >
                  <h4
                    className="title-2"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {managementGalleryTitle}
                  </h4>
                  <p
                    style={{
                      marginBottom: "0",
                      color: "#5c727d",
                      lineHeight: "1.8",
                    }}
                  >
                    {managementGalleryText}
                  </p>
                </div>

                <div className="row g-4 mb-4">
                  {propertyManagementPageImages.slice(1).map((image, index) => {
                    const imageCaptions = [galleryCaptionOne, galleryCaptionTwo];

                    return (
                      <div className="col-md-6" key={image}>
                        <div style={imageCardStyle}>
                          <img
                            src={image}
                            alt={`${copy.imageLabel} ${index + 2}`}
                            style={{
                              width: "100%",
                              height: "290px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <div
                            style={{
                              padding: "16px 18px 18px",
                              background: "#fffdfa",
                              borderTop: "1px solid rgba(187, 165, 92, 0.12)",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "#bba55c",
                                marginBottom: "6px",
                              }}
                            >
                              {copy.imageLabel}
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: "#1f2937",
                                fontWeight: 600,
                                lineHeight: 1.6,
                              }}
                            >
                              {imageCaptions[index] || copy.imageLabel}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <h4 className="title-2 mt-4">{moreDetailsHeading}</h4>

                {(copy.moreDetails || []).map((text, index) => (
                  <LocalizedLeadParagraph
                    key={`below-images-${index}`}
                    text={text}
                    index={index + 10}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.serviceMatrix) && copy.serviceMatrix.length > 0 ? (
                  <div className="qtech-service-matrix">
                    <div className="qtech-service-matrix__header">
                      <span>{matrixHeaderService}</span>
                      <span>{matrixHeaderDetails}</span>
                    </div>
                    {copy.serviceMatrix.map((row, index) => (
                      <div className="qtech-service-matrix__row" key={row.service || index}>
                        <div className="qtech-service-matrix__service">{row.service}</div>
                        <div className="qtech-service-matrix__details">{row.details}</div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    {sidebar.map((item) => (
                      <li
                        key={item.to}
                        className={
                          item.to === "/property-management-saudi-arabia" ? "active" : ""
                        }
                      >
                        <Link to={item.to}>
                          {item.label}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <ServiceInquiryForm
                  serviceTitle={copy.title}
                  serviceSlug="property-management-saudi-arabia"
                />

                <div className="widget ltn__banner-widget">
                  <a href="/shop.html">
                    <img
                      src={propertyManagementSidebarImage}
                      alt={copy.imageLabel}
                      style={{ width: "100%", minHeight: "320px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyManagementServiceDetails;
